import { render, staticRenderFns } from "./DentistSearchPanel.vue?vue&type=template&id=1fc440a2&"
import script from "./DentistSearchPanel.vue?vue&type=script&lang=js&"
export * from "./DentistSearchPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports